import React, {useEffect, useState} from 'react'
import APITable from './ApiTable'
import {fetchAPIusage, APIUsageData} from '../helper'
import SkeletonCard from '../../Auth/Components/SkeletonCard'
import ApiEnterpriseName from './ApiEnterpriseName'
import ApiDatePicker from '../../GenericTable/CommonDatePicker'
import APIDetailsScreen from './ApiDetailsScreen'
import UserDropdown from './UserDropdown'
import ApiDropdown from './APiDropdown'


type SortConfig = {key: string; direction: 'asc' | 'desc' | null}

function APIScreen() {
  // const navigator = useNavigate()
  const [detailScreen, setDetailScreen] = useState(false)
  const [columns, setColumns] = useState<string[]>([])
  const [data, setData] = useState<Record<string, any>[]>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true)
  const [detailProps, setDetailProps] = useState({
    apiKey: '',
    apiName: '',
    userName: '',
  })
  const [selectedEnterprise, setSelectedEnterprise] = useState<null | number>(null)
  const [selectedDays, setSelectedDays] = useState({
    startDate: '',
    endDate: '',
  })
  const [currentPage, setCurrentPage] = useState(1)
  const [currentPageData, setCurrentPageData] = useState<Record<string, any>[]>([])
  const [totalPages, setTotalPages] = useState<number>(1)
  const [sortConfig, setSortConfig] = useState<SortConfig>({key: '', direction: null})
  const [selectedUsers, setSelectedUsers] = useState<any[]>([]);
  const [selectedApis, setSelectedApis] = useState<any[]>([]);
  const itemsPerPage = 10

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedEnterprise) {
        setSelectedApis([]);
        // setData([]);
        // setColumns(APIUsageData.columns);
        // setTotalPages(0);
        return;
      }
  
      setLoading(true);
      try {
        const fetchedData = await fetchAPIusage(
          selectedEnterprise.toString(),
          selectedDays.startDate,
          selectedDays.endDate,
          selectedUsers,
          selectedApis
        );
  
        if (fetchedData.length > 0) {
          const staticColumns = APIUsageData.columns;
          const dynamicColumns = Object.keys(fetchedData[0]).filter(
            (key) => !staticColumns.includes(key)
          );
  
          let updatedColumns = [...staticColumns, ...dynamicColumns];
  
         
          if (selectedUsers.length === 1) {
            updatedColumns = updatedColumns.filter((col) => col !== "User Name");
          }
  
          setColumns(updatedColumns);
          setData(fetchedData);
          setTotalPages(Math.ceil(fetchedData.length / itemsPerPage));
          setCurrentPage(1);
          
        } else {
          setData([]);
          setColumns(APIUsageData.columns);
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [selectedEnterprise, selectedDays, selectedUsers, selectedApis]);


  const sortData = (data: Record<string, any>[], column: string) => {
    const sortableData = [...data]
    sortableData.sort((a, b) => {
      const aValue = a[column]
      const bValue = b[column]

      const aDate = Date.parse(aValue)
      const bDate = Date.parse(bValue)
      if (!isNaN(aDate) && !isNaN(bDate)) {
        return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate
      }

      if (!isNaN(aValue) && !isNaN(bValue)) {
        return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue
      }

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return sortConfig.direction === 'asc'
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue)
      }

      return 0
    })

    return sortableData
  }

  const handleSort = (column: string) => {
    setSortConfig((prevConfig) => {
      const direction = prevConfig.key === column && prevConfig.direction === 'asc' ? 'desc' : 'asc'
      return {key: column, direction}
    })

    const sortedData = sortData(data, column)
    setData(sortedData)
  }

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1)
    }
  }

  const handlePreviousClick = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1)
    }
  }

  const handleDynamicColumnClick = (column: string, row: Record<string, any>) => {
    const apiKey = row['API Key']
    const apiName = column
    const userName = row['User Name']
    setDetailProps({apiKey, apiName, userName})
    setDetailScreen(true)
  }

  const handleBackButtonClick = () => {
    setDetailScreen(false)
  }

  useEffect(() => {
    const filteredData = data.filter((row) => {
      const matchesSearch = Object.values(row)
        .join(' ')
        .toLowerCase()
        .includes(searchTerm.toLowerCase())

      return matchesSearch
    })

    setTotalPages(Math.ceil(filteredData.length / itemsPerPage))

    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    const currentPageData = filteredData.slice(startIndex, endIndex)

    setCurrentPageData(currentPageData)
  }, [data, currentPage, searchTerm])


  return (
    <>
      {!detailScreen ? (
        <div className='card card-flush mb-6 mb-xl-9 mt-5'>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div
            style={{
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              marginLeft: '5px',
            }}
          >
            <div style={{ marginRight: '3px' }}>
              <ApiEnterpriseName
                selectedEnterprise={selectedEnterprise}
                setSelectedEnterprise={setSelectedEnterprise}
              />
            </div>
            {/* Add the UserDropdown component here */}
            <div style={{ marginRight: '3px' }}>
              <UserDropdown
                isDisabled={!selectedEnterprise}
                selectedUsers={selectedUsers}
                setSelectedUsers={setSelectedUsers} selectedEnterprise={selectedEnterprise}/>
            </div>
            <div>
              <ApiDropdown 
              isDisabled={!selectedEnterprise}
              setSelectedApis={setSelectedApis}
              selectedApis={selectedApis}
              selectedEnterprise={selectedEnterprise}
              />
            </div>
          </div>

            <div style={{flex: 0, textAlign: 'right'}}>
              <ApiDatePicker setSelectedDays={setSelectedDays} />
            </div>
          </div>

          {selectedEnterprise ? (
            loading ? (
              <SkeletonCard />
            ) : data.length > 0 ? (
              <>
                <APITable
                  columns={columns}
                  handleNextClick={handleNextClick}
                  handlePriviousClick={handlePreviousClick}
                  data={currentPageData}
                  searchTerm={searchTerm}
                  handleSort={handleSort}
                  sortConfig={sortConfig}
                  onSearch={(term) => {
                    setSearchTerm(term)
                    setCurrentPage(1)
                  }}
                  renderCell={(column, row, rowIndex) => {
                    // Check if the column is one of the dynamic columns
                    if (columns.slice(4).includes(column)) {
                      const value = row[column];
                  
                      // Check if the value is 0 (non-clickable) and apply styles accordingly
                      const isNonClickable = value === 0;
                  
                      return (
                        <span
                          style={{
                            color: isNonClickable ? 'grey' : 'green',
                            cursor: isNonClickable ? 'not-allowed' : 'pointer',
                          }}
                          onClick={() => {
                            // Prevent the click action if the value is 0
                            if (!isNonClickable) {
                              handleDynamicColumnClick(column, row);
                            }
                          }}
                        >
                          <span
                            style={{
                              textDecoration: isNonClickable ? 'none' : 'underline',
                              textUnderlineOffset: '3px',
                            }}
                          >
                            {value}
                          </span>
                        </span>
                      );
                    }
                    return row[column];
                  }}
                  

                  LeftSideElement={<span className="badge badge-light-success" 
                  style={{ fontSize: '14px' ,
                 fontWeight: 'bold',
                 padding: '10px',
                }}>Company Id:{selectedEnterprise}</span>}
                />

                <ul className='pagination justify-content-center' style={{margin: '15px 0'}}>
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button
                      className='page-link'
                      onClick={handlePreviousClick}
                      disabled={currentPage === 1}
                      aria-label='Previous'
                    >
                      &laquo; Previous
                    </button>
                  </li>

                  <li className='page-item active'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='page-link'
                        style={{backgroundColor: '#6D9300', color: '#fff', pointerEvents: 'none'}}
                      >
                        {currentPage}
                      </button>
                      <span className='mx-2'>of</span>
                      <button
                        className='page-link'
                        style={{backgroundColor: '#6D9300', color: '#fff', pointerEvents: 'none'}}
                      >
                        {totalPages}
                      </button>
                    </div>
                  </li>

                  <li className={`page-item ${currentPage >= totalPages ? 'disabled' : ''}`}>
                    <button
                      className='page-link'
                      onClick={handleNextClick}
                      disabled={currentPage >= totalPages}
                      aria-label='Next'
                    >
                      Next &raquo;
                    </button>
                  </li>
                </ul>
              </>
            ) : (
              <div style={{textAlign: 'center', marginTop: '30vh', marginBottom: '30vh'}}>
                <h2>No data available</h2>
              </div>
            )
          ) : (
            <div style={{textAlign: 'center', marginTop: '30vh', marginBottom: '30vh'}}>
              <h2>Select Enterprise to see enterprise farmers</h2>
              <p>Choose an enterprise from the dropdown above to see its API usage.</p>
            </div>
          )}
        </div>
      ) : (
        <APIDetailsScreen
          apiKey={detailProps.apiKey}
          apiName={detailProps.apiName}
          startDate={selectedDays.startDate}
          endDate={selectedDays.endDate}
          userName={detailProps.userName}
          handleBackButtonClick={handleBackButtonClick}
        />
      )}
    </>
  )
}

export default APIScreen
